export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-7dc1f2face231623b1586965591ce855.svg";